import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import ValuePropositionBig from '../ValuePropositionBig/'
import ValuePropositionSmall from '../ValuePropositionSmall'
import {
  SHOP_BY_VEHICLE_TITLE,
  SHOP_BY_VEHICLE_DESCRIPTION,
  SHOP_BY_SIZE_TITLE,
  SHOP_BY_SIZE_DESCRIPTION,
  SHOP_BY_BRANDS_TITLE,
  SHOP_BY_BRANDS_DESCRIPTION,
  APPOINTMENT_DESCRIPTION
} from '../../../constant'

const ValuePropositionWrapper = ({
  hover: {
    byVehicle,
    bySize,
    byBrand,
    appointment
  },
  handleShopByVehicleClick = () => {},
  showNewTireSizeModal = () => {},
  goToRequestAppointmentFlow,
  appointmentTitle,
  ...props
}) =>
  <Wrapper>
    <ValuePropositionBig
      asset={ byVehicle ? 'shop-by-vehicle-white' : 'shop-by-vehicle' }
      title={ SHOP_BY_VEHICLE_TITLE }
      description={ SHOP_BY_VEHICLE_DESCRIPTION }
      alt="byVehicle"
      isHover={ byVehicle }
      click={ handleShopByVehicleClick }
      { ...props } />
    <ValuePropositionBig
      asset={ bySize ? 'shop-by-tire-size-white' : 'shop-by-tire-size-red' }
      title={ SHOP_BY_SIZE_TITLE }
      description={ SHOP_BY_SIZE_DESCRIPTION }
      alt="bySize"
      isHover={ bySize }
      click={ showNewTireSizeModal }
      { ...props } />
    <Row>
      <ValuePropositionSmall
        asset={ byBrand ? 'shop-by-tire-brand-white' : 'shop-by-tire-brand' }
        title={ SHOP_BY_BRANDS_TITLE }
        description={ SHOP_BY_BRANDS_DESCRIPTION }
        link="/tires/brands"
        alt="byBrand"
        { ...props } />
      <ValuePropositionSmall
        asset={ appointment ? 'calendar-new-white' : 'calendar-new' }
        title={ appointmentTitle }
        description={ APPOINTMENT_DESCRIPTION }
        link="#"
        alt="appointment"
        click={ goToRequestAppointmentFlow }
        { ...props } />
    </Row>
  </Wrapper>

ValuePropositionWrapper.propTypes = {
  appointmentTitle: PropTypes.string,
  goToRequestAppointmentFlow: PropTypes.func,
  handleShopByVehicleClick: PropTypes.func,
  hover: PropTypes.shape({
    byVehicle: PropTypes.bool,
    bySize: PropTypes.bool,
    byBrand: PropTypes.bool,
    appointment: PropTypes.bool
  }),
  showNewTireSizeModal: PropTypes.func
}

export default ValuePropositionWrapper

const Wrapper = styled.div`
  ${Media.desktop`
    position: absolute;
    top: 50px;
    right: 50px;
    width: 460px;
    z-index: 1;
  `}
  ${Media.mobile`
    margin: -20px 0 15px;
    padding: 0 20px;
    width: 100%;
  `}
`

const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`
